import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
    catchError,
    filter,
    from,
    map,
    of,
    startWith,
    switchMap,
    take,
    timer,
} from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';

type SubscriptionStatus = 'processing' | 'success' | 'error';

@Component({
    selector: 'app-success',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss']
})
export class SuccessPageComponent {
    private router = inject(Router);
    private auth = inject(AuthService);

    // Poll for subscription status every 3 seconds for up to 1 minute
    // Wait 3 seconds before first check to give webhook time to process
    subscriptionStatus$ = timer(3000, 3000).pipe(
        take(20),
        switchMap((attempt: number) =>
            from(this.auth.refreshUser()).pipe(
                map((user): SubscriptionStatus =>
                    user?.subscribed ? 'success' : attempt >= 19 ? 'error' : 'processing'
                ),
                catchError(() => of<SubscriptionStatus>('processing')),
            )
        ),
        filter((status) => status !== 'processing'),
        startWith<SubscriptionStatus>('processing'),
        take(2), // processing + final state
    );

    navigateToHome(): void {
        this.router.navigate(['/']);
    }
}
